module.exports = __webpack_public_path__ + "img/wallpaper_one.494babb9.png";